import { useState } from "react";
import { Box, Link, Typography } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AttachmentPreviewDialog from "./AttachmentPreviewDialog";

// Small clickable "paperclip + file name" used wherever a payment is listed
// (advance history, settlement history, list columns). Renders nothing when
// there is no attachment, so callers can drop it in unconditionally.
export default function AttachmentLink({ url, name, maxWidth = 160, showEmpty = false }) {
  const [open, setOpen] = useState(false);
  if (!url) {
    return showEmpty ? (
      <Typography variant="caption" color="text.disabled">-</Typography>
    ) : null;
  }
  const label = name || decodeURIComponent(String(url).split("/").pop() || "Attachment");
  return (
    <>
      <Link
        component="button"
        type="button"
        underline="hover"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
        title={`Preview ${label}`}
        sx={{ display: "inline-flex", alignItems: "center", gap: 0.4, fontSize: 12, maxWidth, textAlign: "left" }}
      >
        <AttachFileIcon sx={{ fontSize: 14, flexShrink: 0 }} />
        <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
          {label}
        </Box>
      </Link>
      <AttachmentPreviewDialog open={open} url={url} name={name} onClose={() => setOpen(false)} />
    </>
  );
}

// "url||name@@url||name" (the list APIs' advance_attachments) -> [{url, name}]
export const parseAdvanceAttachments = (value) =>
  String(value || "")
    .split("@@")
    .map((part) => {
      const [url, name] = part.split("||");
      return url ? { url, name: name || "" } : null;
    })
    .filter(Boolean);
